import React, { useCallback, useEffect, useState } from "react";
import "./styles.scss";

import TextField from "@mui/material/TextField";

function DurationField({ field, onHandleChange = () => {} }) {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const setTime = (time) => {
    let days = Math.floor(time / (60 * 60 * 24));
    let hours = Math.floor((time / (60 * 60)) % 24);
    let minutes = Math.floor((time / 60) % 60);

    setDays(days);
    setHours(hours);
    setMinutes(minutes);
  };

  useEffect(() => {
    let time = field.value;
    setTime(time);
  }, [field.value]);

  const handleChange = useCallback((days, hours, minutes) => {
    let time = days * (60 * 60 * 24) + hours * (60 * 60) + minutes * 60;
    onHandleChange(time);
  }, []);

  const handleDaysChange = useCallback(
    (value) => {
      setDays(value);
      handleChange(value, hours, minutes);
    },
    [days, hours, minutes],
  );

  const handleHoursChange = useCallback(
    (value) => {
      setHours(value);
      handleChange(days, value, minutes);
    },
    [days, hours, minutes],
  );

  const handleMinutesChange = useCallback(
    (value) => {
      setMinutes(value);
      handleChange(days, hours, value);
    },
    [days, hours, minutes],
  );

  return (
    <div className="duration-field">
      <TextField
        sx={{ margin: "0 10px" }}
        value={days}
        label="Days"
        type="number"
        required={false}
        size="medium"
        variant="outlined"
        onChange={(e) => handleDaysChange(e.target.value)}
        autoComplete="off"
      />
      <TextField
        sx={{ margin: "0 10px" }}
        value={hours}
        label="Hours"
        type="number"
        required={false}
        size="medium"
        variant="outlined"
        onChange={(e) => handleHoursChange(e.target.value)}
        autoComplete="off"
      />
      <TextField
        sx={{ margin: "0 10px" }}
        value={minutes}
        label="Minutes"
        type="number"
        required={false}
        size="medium"
        variant="outlined"
        onChange={(e) => handleMinutesChange(e.target.value)}
        autoComplete="off"
      />
    </div>
  );
}

export default DurationField;
